import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Loader from "../../components/Loader";
import { ROLES } from "../../constants/UserRoles";
import ViewBatch from "../../components/orgAdmin/students/batches/ViewBatch";
import { ChevronsLeft, ChevronsRight } from "lucide-react";
import RightSide from "../../components/orgAdmin/students/viewBatchRightSide/RightSide";
import AssignModal from "../../components/orgAdmin/students/AssignModal";
import AssignMockInterviewModal from "../../components/orgAdmin/students/AssignMockInterviewModal";

function OrgAdminViewBatch() {
  const [isRightViewOpen, setIsRightViewOpen] = useState(true);
  const [batchDetails, setBatchDetails] = useState(null);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [createbatchFlag, setCreateBatchFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [assignPrepGuideModalFlag, setAssignPrepGuideModalFlag] =
    useState(false);
  const [assignMockInterviewModalFlag, setAssignMockInterviewModalFlag] =
    useState(false);

  const [studentsData, setStudentsData] = useState(null);

  const handleAssignGuide = (userId) => {
    if (userId) {
      setSelectedUserIds([userId]);
    }
    setAssignPrepGuideModalFlag(true);
  };

  const handleAssignMockInterview = (userId) => {
    if (userId) {
      setSelectedUserIds([userId]);
    }
    setAssignMockInterviewModalFlag(true);
  };

  return (
    <>
      {loading && <Loader />}
      {assignPrepGuideModalFlag && (
        <AssignModal
          selectedUserIds={selectedUserIds}
          setAssignPrepGuideModalFlag={setAssignPrepGuideModalFlag}
          assignPrepGuideModalFlag={assignPrepGuideModalFlag}
          setLoading={setLoading}
          batchDetails={batchDetails}
          studentsData={studentsData}
        />
      )}
      {assignMockInterviewModalFlag && (
        <AssignMockInterviewModal
          assignMockInterviewModalFlag={assignMockInterviewModalFlag}
          setAssignMockInterviewModalFlag={setAssignMockInterviewModalFlag}
          setLoading={setLoading}
          selectedUserIds={selectedUserIds}
          batchDetails={batchDetails}
          studentsData={studentsData}
        />
      )}
      <div className="hirePlusPlusPageContent">
        <Sidebar
          collapseSidbar={"left"}
          activePage="students"
          userRole={ROLES.org_admin}
        />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="students"
            userRole={ROLES.org_admin}
            newTitle={
              <div>
                {batchDetails?.batchName || "--"}{" "}
                <span className="font-normal text-[.8rem] text-[#475467]">
                  ({batchDetails?.batchIdentifier || "N/A"})
                </span>
              </div>
            }
            noNavigate={false}
          />
          <div className="px-5 relative">
            <button
              onClick={() => setIsRightViewOpen(!isRightViewOpen)}
              className={`absolute z-50 transition-all duration-300
              ${
                !isRightViewOpen
                  ? "bg-[#EDC043] hover:brightness-110 text-black text-[.85rem] px-2 py-[.38rem] rounded-full shadow-lg right-2 top-2"
                  : "text-amber-500 hover:text-amber-400 top-0 2xl:top-8 2xl:right-8 right-4"
              }`}
              aria-label={
                isRightViewOpen ? "Collapse right panel" : "Expand right panel"
              }
            >
              {isRightViewOpen ? (
                <ChevronsRight size={27} />
              ) : (
                <div className="flex items-center gap-[.15rem] pr-2">
                  <ChevronsLeft size={23} />
                  <div className="font-medium pt-[.1rem]">View Batch</div>
                </div>
              )}
            </button>

            {/* Main Content */}
            <div
              className={`2xl:grid transition-all duration-300 ${
                isRightViewOpen
                  ? "2xl:grid-cols-[3.5fr_1fr] 2xl:gap-[1.2rem]"
                  : "2xl:grid-cols-[1fr_0fr] 2xl:gap-0"
              }`}
            >
              {/* Left Section */}
              <div>
                <ViewBatch
                  batchDetails={batchDetails}
                  setBatchDetails={setBatchDetails}
                  setSelectedUserIds={setSelectedUserIds}
                  selectedUserIds={selectedUserIds}
                  setCreateBatchFlag={setCreateBatchFlag}
                  createbatchFlag={createbatchFlag}
                  setStudentsData={setStudentsData}
                  studentsData={studentsData}
                  onAssignGuide={handleAssignGuide}
                  onAssignMockInterview={handleAssignMockInterview}
                />
              </div>

              {/* Right Section — overlay below 2xl, inline above 2xl */}
              <div
                className={`
                2xl:relative 2xl:translate-x-0 2xl:shadow-none 2xl:bg-transparent 2xl:w-auto 2xl:h-auto 2xl:top-auto 2xl:right-auto
                fixed top-0 right-0 h-full w-[min(22rem,90vw)] bg-white shadow-2xl z-40
                transition-transform duration-300 px-3 pt-5 2xl:p-0
                ${isRightViewOpen ? "translate-x-0" : "translate-x-full 2xl:hidden"}
              `}
              >
                <div className={isRightViewOpen ? "" : "hidden"}>
                  <RightSide
                    batchDetails={batchDetails}
                    selectedUserIds={selectedUserIds}
                    setCreateBatchFlag={setCreateBatchFlag}
                    setLoading={setLoading}
                    studentsData={studentsData}
                    assignPrepGuideModalFlag={assignPrepGuideModalFlag}
                    setAssignPrepGuideModalFlag={setAssignPrepGuideModalFlag}
                    assignMockInterviewModalFlag={assignMockInterviewModalFlag}
                    setAssignMockInterviewModalFlag={setAssignMockInterviewModalFlag}
                  />
                </div>
              </div>
            </div>

            {/* Backdrop — only below 2xl when open */}
            {isRightViewOpen && (
              <div
                className="fixed inset-0 bg-black/60 z-30 2xl:hidden"
                onClick={() => setIsRightViewOpen(false)}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default OrgAdminViewBatch;
